import React from 'react';
import InstrumentDisplayBlock from './InstrumentDisplayBlock';
import './ForSale.css';

interface Instrument {
    instrumentId: number;
    status: string;
    title: string;
    text: string;
}

interface InstrumentImage {
    instrumentId: number;
    filename: string;
    displayStyle: string; // primary, secondary
}

const instruments: Instrument[] = [
    {
        instrumentId: 1,
        status: "ForSale",
        title: "5-String Cello, Alan Goldblatt, Hartland VT, 2003",
        text: "Loosely based on the Montagnana “Sleeping Beauty” cello of 1739 with a stunning back and ribs made from quilted bigleaf maple from Washington state. I converted this cello from 4 to 5 strings (C-G-D-A-E) at the request of the current owner, which included a complete new setup and geared ebony Pegheds for ease of tuning. This is not a diminutive violoncello piccolo, but a robust full-size string length cello (69.2cm) that has the versatility to play repertoire from classical to folk, with either period or modern stringing/tuning. In exceptional condition. Option to include BAM Newtech case, in black. $18,500."
    },
    {
        instrumentId: 2,
        status: "Sold",
        title: "Baroque Violin, Desiderio Quercetani, Parma, 2006",
        text: "4/4 Stradivari model in as-new condition. An excellent dedicated baroque violin for the serious student or professional, by the maker who built many of the instruments for the Europa Galante orchestra. Body length: 35.6cm. String length: 32.7cm. $7300"
    },
    {
        instrumentId: 3,
        status: "Sold",
        title: "Composite 18th-19th century Germanic Viola",
        text: "A unique and fine sounding small viola, with a body length just under 15 inches and a comfortable string length of 34.9cm/~14 inches.  The top and ribs of an 18th century viola d’amore were used with a later arched back and scroll to create a 4-string viola.  This instrument works well in modern setup, but would also be appropriate for baroque performance, and possibly even further conversion into a 5-string viola or viola d’amore.  Please contact for price and more details."
    },
    {
        instrumentId: 4,
        status: "Sold",
        title: "Knopf-school Viola Bow, late 19th century",
        text: "A round figured snakewood bow with nickel fittings and handsome lined abalone eyes and slide to the ebony frog.  67.3 grams, 73.9 cm total length.  Please contact for price. This item has the option of being offered in tandem with the composite viola above."
    },
    {
        instrumentId: 5,
        status: "Sold",
        title: "Six-String Bass Viol, Dominik Zuchowicz, Ottawa, 1998",
        text: "A plainly decorated Barak Norman model (70cm string length) by the well respected, late luthier. Black Mooradian bag included. Excellent repaired condition. $8000"
    },
    {
        instrumentId: 6,
        status: "Sold",
        title: "Seven-String Bass Viol, Charlie Ogle Workshops, Beijing, 2007",
        text: "Nicolas Bertrand model (71 cm string length) is as-new condition. Dark green fiberglass case and Chinese concave-camber snakewood bow (70g) included. Sold June 2022."
    }
];

const images: InstrumentImage[] = [
    // instrumentId 1
    { instrumentId: 1, filename: "CelloGoldblatt01.jpg", displayStyle: "primary" },
    { instrumentId: 1, filename: "CelloGoldblatt02.jpg", displayStyle: "primary" },
    { instrumentId: 1, filename: "CelloGoldblatt03.jpg", displayStyle: "secondary" },
    { instrumentId: 1, filename: "CelloGoldblatt04.jpg", displayStyle: "secondary" },
    { instrumentId: 1, filename: "CelloGoldblatt05.jpg", displayStyle: "secondary" },
    { instrumentId: 1, filename: "CelloGoldblatt06.jpg", displayStyle: "secondary" },
    { instrumentId: 1, filename: "CelloGoldblatt07.jpg", displayStyle: "secondary" },
    // instrumentId 2
    { instrumentId: 2, filename: "ViolinQuercetani01.jpeg", displayStyle: "primary" },
    { instrumentId: 2, filename: "ViolinQuercetani02.jpeg", displayStyle: "primary" },
    { instrumentId: 2, filename: "ViolinQuercetani03.jpeg", displayStyle: "secondary" },
    { instrumentId: 2, filename: "ViolinQuercetani04.jpeg", displayStyle: "secondary" },
    { instrumentId: 2, filename: "ViolinQuercetani05.jpeg", displayStyle: "secondary" },
    { instrumentId: 2, filename: "ViolinQuercetani06.jpeg", displayStyle: "secondary" },
    // instrumentId 3
    { instrumentId: 3, filename: "ViolaGerman01.jpeg", displayStyle: "primary" },
    { instrumentId: 3, filename: "ViolaGerman02.jpeg", displayStyle: "primary" },
    { instrumentId: 3, filename: "ViolaGerman03.jpeg", displayStyle: "secondary" },
    { instrumentId: 3, filename: "ViolaGerman04.jpeg", displayStyle: "secondary" },
    { instrumentId: 3, filename: "ViolaGerman05.jpeg", displayStyle: "secondary" },
    // instrumentId 4
    { instrumentId: 4, filename: "BowKnopf01.jpeg", displayStyle: "primary" },
    { instrumentId: 4, filename: "BowKnopf02.jpeg", displayStyle: "primary" },
    { instrumentId: 4, filename: "BowKnopf03.jpeg", displayStyle: "secondary" },
    // instrumentId 5
    { instrumentId: 5, filename: "BassViolZuchowicz01.jpeg", displayStyle: "primary" },
    { instrumentId: 5, filename: "BassViolZuchowicz02.jpeg", displayStyle: "primary" },
    { instrumentId: 5, filename: "BassViolZuchowicz03.jpeg", displayStyle: "secondary" },
    { instrumentId: 5, filename: "BassViolZuchowicz04.jpeg", displayStyle: "secondary" },
    { instrumentId: 5, filename: "BassViolZuchowicz05.jpeg", displayStyle: "secondary" },
    { instrumentId: 5, filename: "BassViolZuchowicz06.jpeg", displayStyle: "secondary" },
    // instrumentId 6
    { instrumentId: 6, filename: "BassViolOgle01.jpeg", displayStyle: "primary" },
    { instrumentId: 6, filename: "BassViolOgle02.jpeg", displayStyle: "primary" },
    { instrumentId: 6, filename: "BassViolOgle03.jpeg", displayStyle: "secondary" },
    { instrumentId: 6, filename: "BassViolOgle04.jpeg", displayStyle: "secondary" },
    { instrumentId: 6, filename: "BassViolOgle05.jpeg", displayStyle: "secondary" }
];

// ...existing code for interfaces and static arrays...

const ForSale: React.FC = () => {
    // Filter out instruments without a title
    const validInstruments = instruments.filter((inst: Instrument) => inst.title && inst.title.trim() !== '');

    // Sort: ForSale first, then SOLD, preserving original order within each group
    const sortedInstruments = [...validInstruments].sort((a, b) => {
        const statusA = a.status?.toLowerCase() === 'forsale' ? 0 : 1;
        const statusB = b.status?.toLowerCase() === 'forsale' ? 0 : 1;
        return statusA - statusB;
    });

    return (
        <section>
            <h2>For Sale</h2>
            <div>Occasionally, I will have instruments and bows for sale by other makers, both antique and contemporary. Any item that I offer adheres to my strict criteria of condition and quality. If you have any inquiries about the items currently on offer, or would like to arrange a trial, please email, text or call.</div>

            {/* Table of Contents */}
            {sortedInstruments.length > 0 && (
                <nav style={{ margin: '2rem 0' }}>
                    <ul>
                        {sortedInstruments.map((inst: Instrument) => (
                            <li key={inst.instrumentId}>
                                <a href={`#instrument-${inst.instrumentId}`}>
                                    {inst.title}
                                </a>
                                {inst.status && inst.status.toLowerCase() === 'sold' ? ' [SOLD]' : ''}
                            </li>
                        ))}
                    </ul>
                </nav>
            )}

            {/* Instruments List */}
            {sortedInstruments.map((inst: Instrument, idx: number) => {
                // Find images for this instrument
                const instrumentImages = images
                    .filter((img: InstrumentImage) => img.instrumentId === inst.instrumentId)
                    .map((img: InstrumentImage) => ({
                        src: `/images/${img.filename}`,
                        alt: inst.title,
                        displayStyle: img.displayStyle,
                    }));

                return (
                    <React.Fragment key={inst.instrumentId}>
                        <div id={`instrument-${inst.instrumentId}`} style={{ scrollMarginTop: '80px' }}>
                            <InstrumentDisplayBlock
                                title={
                                    inst.title + (inst.status && inst.status.toLowerCase() === 'sold' ? ' [SOLD]' : '')
                                }
                                text={inst.text}
                                images={instrumentImages}
                            />
                        </div>
                        {idx < sortedInstruments.length - 1 && <hr className="instrument-divider" />}
                    </React.Fragment>
                );
            })}
        </section>
    );
};
export default ForSale;
